export default __webpack_public_path__ + "static/media/eternamente-logo.77db6aac.png";